/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-width[_ngcontent-%COMP%]{width:100%}.header[_ngcontent-%COMP%]{display:flex;align-items:center;background:#f7f7f7;padding:5px 15px;margin-top:8px;margin-bottom:8px;border-radius:3px;border:1px solid #e2e2e2}.header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{padding-left:10px}.action-buttons[_ngcontent-%COMP%]{justify-content:flex-end}"];
export { styles as styles };
